
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialDetailsDialog extends _Ext.EditorDialogBase<ReceiptMaterialDetailsRow> {
        protected getFormKey() { return ReceiptMaterialDetailsForm.formKey; }
        //protected getIdProperty() { return ReceiptMaterialDetailsRow.idProperty; }
        //protected getLocalTextPrefix() { return ReceiptMaterialDetailsRow.localTextPrefix; }
        protected getNameProperty() { return ReceiptMaterialDetailsRow.nameProperty; }
        //protected getService() { return ReceiptMaterialDetailsService.baseUrl; }
        //protected getDeletePermission() { return ReceiptMaterialDetailsRow.deletePermission; }
        //protected getInsertPermission() { return ReceiptMaterialDetailsRow.insertPermission; }
        //protected getUpdatePermission() { return ReceiptMaterialDetailsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public form = new ReceiptMaterialDetailsForm(this.idPrefix);
        constructor() {
            super();
            //q.hideImageToolbar(this.form.ImageName);
            //q.hideEditorLabel(this.form.ImageName);
            //q.SetCategorySixColumn(this.form.TransDate);
            //q.SetCategoryTwoColumn(this.form.ImageName);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.initDetailEditor(this, this.form.ItemDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.HideCategoryLable(this.element);
            this.form.DepartmentId.changeSelect2(e => {
                this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            });
            this.form.BagNo.changeSelect2(e => {
                this.form.ItemDetails.BagNo = this.form.BagNo.value;
                this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value)
         
                let oldworkorderdetails;
                WIPMovementSelectService.List({ BagNo: this.form.BagNo.value, DepartmentId: parseInt(this.form.DepartmentId.value) }, response => oldworkorderdetails = response.Entities[0], { async: false });


                this.form.Line_No.value = oldworkorderdetails.LineNo.toString();
                this.entity.SubBagNo = oldworkorderdetails.SubBagNo;
                this.form.ProductId.value = oldworkorderdetails.ProductId.toString();
                this.form.AttributeId.value = oldworkorderdetails.AttributeId.toString();
                this.form.Attribute.value = oldworkorderdetails.Attribute;
                this.form.ItemDetails.LineNo = parseInt(this.form.Line_No.value);
                this.form.Pieces.value = oldworkorderdetails.Pieces;
                this.form.ProductCode.value = oldworkorderdetails.ProductCode;
                var productImage = oldworkorderdetails.ImageName;
                var image: Serenity.UploadedFile = {
                    Filename: productImage,
                    OriginalName: ""
                }

            });
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );


        }
        public CalculateTotals() {
            var Wt = 0, diapcs = 0, cts = 0, gms = 0, rate = 0;
            for (var k of this.form.ItemDetails.getItems()) {

                if (k.ItemTypeId == 104) {
                    Wt += k.Weight;
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                    cts += k.Weight;
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                    gms += k.Weight;
                }


                if (cts > 0)
                    this.form.Weight.value = Wt + gms + (cts / 5);
                else
                    this.form.Weight.value = Wt + gms;

                //rate += k.BomAmount;

            }
        }

        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {
                var grid = WIPMovementSelectGrid;
                var filters: _Ext.SelectGridFilters = {
                    PartyId: 0,
                    DepartmentId: Q.parseInteger(this.form.DepartmentId.value)
                }

                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Work Order", height: 500, Width: 750, GridFilters: filters
                });
                pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {

                    if (selectedItems.length > 0) {

                        this.form.BagNo.value = selectedItems[0].BagNo;
                        this.form.ItemDetails.BagNo = selectedItems[0].BagNo;
                        this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
                        this.form.Line_No.value = selectedItems[0].Line_No.toString();
                        this.form.ProductId.value = selectedItems[0].ProductId.toString();
                        this.form.AttributeId.value = selectedItems[0].AttributeId.toString();
                        this.form.Attribute.value = selectedItems[0].Attribute;
                        this.form.ItemDetails.LineNo = parseInt(this.form.Line_No.value);
                        this.form.Pieces.value = selectedItems[0].Pieces;
                        this.form.ProductCode.value = selectedItems[0].ProductCode;
                        this.entity.SubBagNo = selectedItems[0].SubBagNo;
                        //Common.WorkOrderStockSelectGrid.BagNo = selectedItems[0].BagNo;



                        //this.CalculateTotals();
                    }
                }
                pickerDialog.dialogOpen();

            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }

    }
}